import React, { useEffect, useState } from "react";

import closeIcon from "../../../../../assets/closeModel.png";
import checkedIcon from "../../../../../assets/check-mark.png";
import deleteIcon from "../../../../../assets/trash.png";
import {
  DialogContent,
  DialogContentText,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";
import { useDispatch } from "react-redux";
import useStyles from "../../../../../components/common/model/styles";
import Popup from "../../../../../components/common/model/Popup";
import Notification from "../../../../../components/common/notification/Notification";
import FormField from "../../../../../components/common/FormField";
import Validation from "../../../../../utils/Validation";
import { GENERAL_LEAD_NOTIFICATION_FIELDS } from "../allFieldUtil";
import ResetFormAlert from "../../../../../components/common/ResetFormAlert";
import { updateLeadNotificationAction } from "../../../../../store/reducers/reviewSlice";

interface formDataType {
  [key: string]: any; // Allow dynamic string keys
  message: string;
  color: string;
  forward_days: string;
  old_days: string;
}

interface ManageLeadNotificationProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectUser: any; // Adjust type as per your requirement
  isSmallScreen?: boolean; //
}

const ManageLeadNotification = (props: ManageLeadNotificationProps) => {
  const classes = useStyles();
  const { selectUser, onHide, open, title, isSmallScreen } = props;

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);
  const [formData, setFormData] = useState<formDataType>({
    message: "",
    color: "",
    forward_days: "",
    old_days: "",
  });

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    message: formData?.message,
    color: formData?.color,

  });

  useEffect(() => {
    if (selectUser) {
      setFormData({
        message: selectUser?.message || "",
        color: selectUser?.color || "",
        forward_days: selectUser?.forward_days || "",
        old_days: selectUser?.old_days || "",
      });
    }
  }, [selectUser]);
  const dispatch = useDispatch();

  const [isActionCalled, setIsActionCalled] = useState(false);

  const handleInputChange = (fieldId: string, value: string) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldId]: value,
    }));
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  const hideHandler = () => {
    resetAllValidator();
    onHide();
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

 const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        const newPayload={
          ...formData,
          id: selectUser?.id,
          forward_days: formData?.forward_days ? Number(formData.forward_days) : null,
          old_days: formData?.old_days ? Number(formData.old_days) : null,
        }
        if (selectUser?.id) {
          dispatch(updateLeadNotificationAction(newPayload));
        } 
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  useEffect(() => {
    if (isClickReset) {
      if (selectUser?.id) {
        setFormData({
          message: selectUser?.message || "",
          color: selectUser?.color || "",
          forward_days: selectUser?.forward_days || "",
          old_days: selectUser?.old_days || "",
        });
      } else {
        setFormData({
          message: "",
          color: "",
          forward_days: "",
          old_days: "",
        });
      }
    }
    setIsClickReset(false);
    setAlertModelShow(false);
  }, [isClickReset]);

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"sm"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                direction="row"
                spacing={0.5}
                rowGap={0}
                rowSpacing={0}
                sx={{
                  background: "#E5F4F1",
                  padding: "10px !important",
                  marginTop: "10px !important",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                  overflow: "hidden",
                }}
              >
                {/* Always show message and color fields for all message_ids */}
                {GENERAL_LEAD_NOTIFICATION_FIELDS.filter(
                  (f) => f.id === "message" || f.id === "color",
                ).map((field, i) => (
                  <FormField
                    key={field.id}
                    onPaste={(e) =>
                      field?.id === "name" ? "" : e.preventDefault()
                    }
                    onKeyDown={(event: any) => {
                      if (
                        event.keyCode === 8 ||
                        event.keyCode === 9 ||
                        event.keyCode === 37 ||
                        event.keyCode === 38 ||
                        event.keyCode === 39 ||
                        event.keyCode === 40 ||
                        event.keyCode === 18 ||
                        event.keyCode === 17 ||
                        event.ctrlKey
                      )
                        return event;
                      if (
                        field?.patternAllowed &&
                        !field?.patternAllowed.test(event.key)
                      ) {
                        event.preventDefault();
                      } else if (
                        field?.patternAllowed &&
                        !field?.patternAllowed.test(
                          event.target.value + event.key,
                        )
                      ) {
                        event.preventDefault();
                      }
                    }}
                    {...{
                      ...field,
                      ...{
                        variant: "outlined",
                        inSingleGridForm: true,
                        isNonMarginTop: true,
                        InputProps: {
                          ...(field?.inputProps && field?.inputProps),
                          sx: {
                            height:
                              field?.id === "notes" &&
                              formData[field?.id]?.length > 36
                                ? "auto"
                                : "36px",
                            padding: field?.id === "notes" ? "4px" : "",
                          },
                          autocomplete: "user-new-field",
                        },
                        value: formData[field.id],
                        onBlur: onBlurAction,
                        onChange: (e: any) =>
                          handleInputChange(field.id, e.target.value),
                        error: error && error[field?.id],
                      },
                    }}
                  />
                ))}

                {/* Custom range UI for message_id 5, with label 'Overdue' */}
                {selectUser?.message_id === 5 && (
                  <>
                    <InputLabel
                      style={{
                        marginLeft: 4,
                        color: "#637381",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                    >
                      Days from today's date
                    </InputLabel>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        background: "#e5f4f1",
                        padding: "16px 0",
                        justifyContent: "left",
                      }}
                    >
                
                      <input
                        type="text"
                        value={formData.forward_days}
                        onChange={(e) =>
                          handleInputChange("forward_days", e.target.value)
                        }
                        style={{
                          width: 90,
                          marginRight: 12,
                          border: "1px solid #e5f4f1",
                          borderRadius: 2,
                          height: 32,
                          background: "#fff",
                          textAlign: "center",
                        }}
                        placeholder=""
                      />
                      <span style={{ margin: "0 8px", fontWeight: "bold" }}>
                        to
                      </span>
                     
                      <input
                        type="text"
                        value={formData.old_days}
                        onChange={(e) =>
                          handleInputChange("old_days", e.target.value)
                        }
                        style={{
                          width: 90,
                          border: "1px solid #e5f4f1",
                          borderRadius: 2,
                          height: 32,
                          background: "#fff",
                          textAlign: "center",
                        }}
                        placeholder=""
                      />
                    </Grid>
                  </>
                )}

                {/* Other fields for other message_ids */}
                {selectUser?.message_id !== 5 &&
                  GENERAL_LEAD_NOTIFICATION_FIELDS.map((field, i) => {
                    // Only show 'forward_days' fields for message_id 3, 4
                    // Only show 'old_days' field for message_id 6
                    // Hide both for message_id 1, 2
                    if (field.id === "forward_days") {
                      if (![3, 4].includes(selectUser?.message_id)) {
                        return null;
                      }
                    }
                    if (field.id === "old_days") {
                      if (selectUser?.message_id !== 6) {
                        return null;
                      }
                    }
                    if (
                      [1, 2].includes(selectUser?.message_id) &&
                      (field.id === "forward_days" || field.id === "old_days")
                    ) {
                      return null;
                    }
                    if (field.id === "message" || field.id === "color") {
                      return null; // Already rendered above
                    }
                    return (
                      <FormField
                        key={field.id}
                        onPaste={(e) =>
                          field?.id === "name" ? "" : e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (
                            event.keyCode === 8 ||
                            event.keyCode === 9 ||
                            event.keyCode === 37 ||
                            event.keyCode === 38 ||
                            event.keyCode === 39 ||
                            event.keyCode === 40 ||
                            event.keyCode === 18 ||
                            event.keyCode === 17 ||
                            event.ctrlKey
                          )
                            return event;
                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          } else if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(
                              event.target.value + event.key,
                            )
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...field,
                          ...{
                            label:
                              selectUser?.message_id === 1 &&
                              field?.id === "forward_days"
                                ? "Contact Soon"
                                : field?.label,
                            variant: "outlined", // Adding this variant prop
                            inSingleGridForm: true,
                            isNonMarginTop: true,
                            InputProps: {
                              ...(field?.inputProps && field?.inputProps),
                              sx: {
                                height:
                                  field?.id === "notes" &&
                                  formData[field?.id]?.length > 36
                                    ? "auto"
                                    : "36px",
                                padding: field?.id === "notes" ? "4px" : "",
                              },
                              autocomplete: "user-new-field",
                            },
                            value: formData[field.id],
                            onBlur: onBlurAction,
                            onChange: (e: any) =>
                              handleInputChange(field.id, e.target.value),
                            error: error && error[field?.id],
                          },
                        }}
                      />
                    );
                  })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageLeadNotification;
